// SVG Component Props
interface SVGComponentProps {
  className?: string;
}

export const AppStoreBadge: React.FC<SVGComponentProps> = ({ className }) => {
    return (
        <svg className={className} width="168" height="56" viewBox="0 0 168 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="168" height="56" rx="8" fill="#000"/>
          <g fill="#fff">
            <text x="55" y="22" fontFamily="Inter, sans-serif" fontSize="10">Download on the</text>
            <text x="55" y="38" fontFamily="Inter, sans-serif" fontSize="18" fontWeight="600">App Store</text>
          </g>
          <g transform="translate(14, 12)">
            <path d="M19.037 17.163c-.026-2.87 2.371-4.26 2.482-4.33-1.359-1.973-3.466-2.243-4.206-2.266-1.774-.182-3.488 1.058-4.392 1.058-.921 0-2.319-1.038-3.823-1.007-1.94.03-3.746 1.147-4.74 2.882-2.049 3.525-.522 8.705 1.44 11.557.977 1.397 2.122 2.958 3.625 2.903 1.466-.06 2.014-.936 3.786-.936 1.756 0 2.267.936 3.8.9 1.576-.024 2.566-1.402 3.505-2.812 1.13-1.601 1.584-3.177 1.6-3.258-.036-.013-3.044-1.153-3.077-4.691z" fill="#fff"/>
            <path d="M16.137 8.592c.789-.976 1.33-2.302 1.18-3.647-1.144.049-2.567.782-3.39 1.738-.729.85-1.38 2.239-1.212 3.546 1.284.096 2.603-.647 3.422-1.637z" fill="#fff"/>
          </g>
        </svg>
    );
  };